import { AllowedResolution } from "../../../constants/resize";

export const getImageUrl = (
  domain?: string,
  path?: string,
  size?: AllowedResolution
): string => {
  return domain && path
    ? `${domain}/images/${
        !size || size === "size-full" ? "" : size + "/"
      }${path}`
    : "";
};
